import { render, staticRenderFns } from "./DrawShare.vue?vue&type=template&id=c4aff1f2&scoped=true&"
import script from "./DrawShare.vue?vue&type=script&lang=js&"
export * from "./DrawShare.vue?vue&type=script&lang=js&"
import style0 from "./DrawShare.vue?vue&type=style&index=0&id=c4aff1f2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4aff1f2",
  null
  
)

export default component.exports